import { c as _c } from "react/compiler-runtime";
import { Divider, Stack } from '@mui/material';
import { useRef, type UIEventHandler } from 'react';
import { Icon } from '@/components/shared/icon';
export const SelectedItemsBody = t0 => {
  const $ = _c(15);
  const {
    items,
    renderItem,
    itemKey,
    onRemove,
    onScrollVerticallyChange
  } = t0;
  const isScrolledVertically = useRef(false);
  let t1;
  if ($[0] !== onScrollVerticallyChange) {
    t1 = event => {
      const target = event.target as HTMLDivElement;
      if (typeof target.scrollTop === "number") {
        const isScrolled = target.scrollTop > 0;
        if (isScrolled !== isScrolledVertically.current) {
          isScrolledVertically.current = isScrolled;
          onScrollVerticallyChange?.(isScrolled);
        }
      }
    };
    $[0] = onScrollVerticallyChange;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const onScroll = t1;
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <Divider sx={{
      paddingY: "2px"
    }} />;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const t3 = onScrollVerticallyChange ? onScroll : undefined;
  let t4;
  if ($[3] !== itemKey || $[4] !== items || $[5] !== onRemove || $[6] !== renderItem) {
    let t5;
    if ($[8] !== itemKey || $[9] !== onRemove || $[10] !== renderItem) {
      t5 = item => <Stack width="100%" direction="row" alignItems="center" key={itemKey(item)} justifyContent="space-between" className="px-[24px]">{renderItem(item)}<Icon onClick={() => onRemove(item)} iconClass="material-symbols-close-rounded" /></Stack>;
      $[8] = itemKey;
      $[9] = onRemove;
      $[10] = renderItem;
      $[11] = t5;
    } else {
      t5 = $[11];
    }
    t4 = items.map(t5);
    $[3] = itemKey;
    $[4] = items;
    $[5] = onRemove;
    $[6] = renderItem;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[12] !== t3 || $[13] !== t4) {
    t5 = <Stack flexGrow={1} overflow="auto" height="auto" className="py-[12px]" gap="8px" divider={t2} onScroll={t3}>{t4}</Stack>;
    $[12] = t3;
    $[13] = t4;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  return t5;
};